import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from "emailjs-com";
import styles from "./MainContent.module.css";
import { useLocale } from '../aboutUs/LocaleContext';

export const CallToAction = ({ heading, subHeading }) => {
  const { locale } = useLocale();
  const t = locale === 'pt-BR' ? {
    placeholder: 'seu@email.com',
    lead: 'Não perca – cadastre-se para receber insights Neuro Token!',
    signing: 'Cadastrando...',
    signup: 'Cadastrar',
    success: 'Obrigado pelo cadastro! Verifique seu e-mail para confirmação.',
    errorInvalid: 'Por favor insira um e-mail válido.',
    errorSend: 'Falha ao enviar. Tente novamente mais tarde.'
  } : {
    placeholder: 'your@email.com',
    lead: "Don't miss out – sign up for Neuro Token insights!",
    signing: 'Signing up...',
    signup: 'Sign up!',
    success: 'Thank you for signing up! Please check your email for confirmation.',
    errorInvalid: 'Please enter a valid email address.',
    errorSend: 'Failed to send the email. Please try again later.'
  };
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleSignUp = (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    if (!email) {
      setError(t.errorInvalid);
      setLoading(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(t.errorInvalid);
      setLoading(false);
      return;
    }

    //  Replace the placeholders below with your emailjs service ID, template ID, and user ID
    // im using right now my own Gmail account to send the email
    // if Tommy asked why we didnt use Miscrosoft Dynamics 365 Marketing its because EmailJS pricing is significantly lower and simpler, often based on the number of emails sent per month.
    // while Dynamics 365 Marketing: have Base Cost: $1,200 per tenant/month.since our requirements are more basic and cost-sensitive, continuing with EmailJS would be more economical.
    // switching to Dynamics 365 Marketing maybe in future cuz it provide a robust marketing automation platform with extensive features
    // advanced marketing automation, customer journey management, and CRM integration

    // make sure
    // to put this in the .env file
    const serviceID = process.env.REACT_APP_SERVICE_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID;
    const userID = process.env.REACT_APP_USER_ID;
    console.log(serviceID, templateID, userID);
    const templateParams = {
      user_email: email.trim(),
    };

    emailjs
      .send(serviceID, templateID, templateParams, userID)
      .then((response) => {
        setLoading(false);
        setMessage(t.success);
        setEmail("");
      })
      .catch((error) => {
        setLoading(false);
        setError(t.errorSend);
      });
  };

  return (
    <div className={styles.textSection} style={{ position:'relative', zIndex:2 }}>
      <div className={styles.subHeading}>{subHeading}</div>
      <h2 className={styles.heading} style={{ fontSize:'clamp(1.8rem,4.8vw,3.2rem)', lineHeight:1.15, fontWeight:800, letterSpacing:'-.5px', background:'linear-gradient(90deg,#14B88D,#F5C84C,#ffffff)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', margin:'6px 0 10px' }}>{heading}</h2>
      <div className={styles.callToAction} style={{ background:'linear-gradient(150deg, rgba(24,42,34,.55), rgba(18,24,26,.7))', padding:'1rem 1.1rem .95rem', borderRadius:18, border:'1px solid #14B88D55', backdropFilter:'blur(8px)', boxShadow:'0 6px 24px -8px #14B88D33, 0 1.5px 0 #F5C84C44' }}>
        <span style={{ fontSize:'0.78rem', letterSpacing:'.6px', color:'#BFEFDD', fontWeight:500 }}>{t.lead}</span>
        <form onSubmit={handleSignUp} aria-live="polite" style={{ marginTop:'.75rem' }}>
          <div className={styles.inputWrapper} style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap' }}>
            <input
              type="email"
              placeholder={t.placeholder}
              className={styles.emailInput}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              aria-label={locale==='pt-BR'? 'E-mail para cadastro' : 'Email for signup'}
              style={{ background:'rgba(255,255,255,0.06)', border:'1px solid rgba(20,184,141,0.35)', color:'#E9F8F2', fontSize:'.8rem', padding:'12px 14px', borderRadius:12, flex:'1 1 260px', outline:'none' }}
            />
            <motion.button
              type="submit"
              className={styles.signUpButton}
              disabled={loading}
              style={{ background:'linear-gradient(90deg,#14B88D,#F5C84C)', color:'#0C0D0E', fontWeight:700, fontSize:'.8rem', padding:'14px 20px', borderRadius:14, cursor:'pointer', letterSpacing:'.6px', border:'none', boxShadow:'0 8px 24px -10px #14B88D55, 0 2px 0 #F5C84C55', position:'relative', overflow:'hidden' }}
              whileHover="sparkle"
              whileFocus="sparkle"
              animate="rest"
              variants={{}}
            >
              <span style={{ position:'relative', zIndex:2 }}>{loading ? t.signing : t.signup}</span>
              <AnimatePresence>
                <motion.svg
                  key="sparkle"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: [0, 1, 0], scale: [0.8, 1.2, 1] }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.7 }}
                  style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 1 }}
                  viewBox="0 0 80 40"
                >
                  <g>
                    <motion.circle cx="20" cy="12" r="2.2" fill="#F5C84C" animate={{ scale: [1, 1.5, 1], opacity: [0.7, 1, 0.7] }} transition={{ duration: 0.7, repeat: Infinity, repeatType: 'reverse', delay: 0.1 }} />
                    <motion.circle cx="40" cy="8" r="1.5" fill="#14B88D" animate={{ scale: [1, 1.3, 1], opacity: [0.6, 1, 0.6] }} transition={{ duration: 0.7, repeat: Infinity, repeatType: 'reverse', delay: 0.2 }} />
                    <motion.circle cx="60" cy="18" r="1.8" fill="#fff" animate={{ scale: [1, 1.4, 1], opacity: [0.5, 1, 0.5] }} transition={{ duration: 0.7, repeat: Infinity, repeatType: 'reverse', delay: 0.3 }} />
                    <motion.circle cx="30" cy="28" r="1.2" fill="#F5C84C" animate={{ scale: [1, 1.2, 1], opacity: [0.5, 1, 0.5] }} transition={{ duration: 0.7, repeat: Infinity, repeatType: 'reverse', delay: 0.4 }} />
                  </g>
                </motion.svg>
              </AnimatePresence>
            </motion.button>
          </div>
        </form>
        {error && <div className={styles.errorMessage} style={{ color:'#F5C84C', fontSize:'.65rem', marginTop:'.6rem' }}>{error}</div>}
        {message && <div className={styles.successMessage} style={{ color:'#14B88D', fontSize:'.65rem', marginTop:'.6rem' }}>{message}</div>}
      </div>
    </div>
  );
};
